import { render, staticRenderFns } from "./WorkflowEditor.vue?vue&type=template&id=3fdf3a6c&scoped=true&"
import script from "./WorkflowEditor.vue?vue&type=script&lang=ts&"
export * from "./WorkflowEditor.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowEditor.vue?vue&type=style&index=0&id=3fdf3a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf3a6c",
  null
  
)

export default component.exports